/** Numeric search stays textual, including amounts above Number.MAX_SAFE_INTEGER. */
export function matchesNumeric(raw: string, formatted: string, query: string): boolean {
  const compact = (value: string) => value.replace(/\s/g, '').toLowerCase();
  if (compact(formatted).includes(compact(query))) return true;
  const numeric = query.trim().replace(/^(?:[a-z]{3}|r\$|[$€£¥])\s*/i, '').replace(/\s/g, '');
  if (!/^-?\d[\d.,]*$/.test(numeric)) return false;
  const candidates = new Set([numeric]);
  if (numeric.includes(',')) candidates.add(numeric.replace(/\./g, '').replace(',', '.'));
  // A grouped integer such as 10.000 can also be searched as 10000.
  if (/^-?\d{1,3}(\.\d{3})+$/.test(numeric)) candidates.add(numeric.replace(/\./g, ''));
  if (/^-?\d{1,3}(,\d{3})+(\.\d+)?$/.test(numeric)) candidates.add(numeric.replace(/,/g, ''));
  return [...candidates].some(candidate => raw.includes(candidate));
}
